'use client';
import { Root, CategoryContainer, ListContainer, Category, List } from './MultiColumnList.parts.js';

/**
 * @description 다중 컬럼 리스트를 구성하는 컴포넌트들의 모음입니다.
 * @property {RootProps} Root - 목록 컨테이너
 * @property {CategoryContainerProps} CategoryContainer - 카테고리 컨테이너(좌측)
 * @property {ListContainerProps} ListContainer - 리스트 컨테이너(우측)
 * @property {CategoryProps} Category - 카테고리
 * @property {ListProps} List - 리스트
 *
 * @example
 * // 기본 사용 예시
 * <MultiColumnList.Root>
 *   <MultiColumnList.CategoryContainer>
 *     <MultiColumnList.Category>카테고리 1</MultiColumnList.Category>
 *     <MultiColumnList.Category>카테고리 2</MultiColumnList.Category>
 *   </MultiColumnList.CategoryContainer>
 *
 *   <MultiColumnList.ListContainer>
 *     <MultiColumnList.List>
 *       <li>항목 1</li>
 *       <li>항목 2</li>
 *     </MultiColumnList.List>
 *     <MultiColumnList.List>
 *       <li>항목 3</li>
 *       <li>항목 4</li>
 *     </MultiColumnList.List>
 *   </MultiColumnList.ListContainer>
 * </MultiColumnList.Root>
 */ const MultiColumnList = {
    Root,
    CategoryContainer,
    ListContainer,
    Category,
    List
};

export { MultiColumnList as default };
